/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, April 25th 2022, 8:16:50 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

export enum SERVICE_BUILDER_RELATIVE_URLS {
  services = "services/",
  serviceBuilderRoot = `services/edit/:serviceId`,
  submissionForms = "services/edit/:serviceId/submission-forms",
  serviceRegistrationForms = "services/edit/:serviceId/service-registration-forms",
  stage = "services/edit/:serviceId/stage/:stageId",
  serviceFormBuilder = "services/edit/:serviceId/form-builder/:formId",
  documentTemplatesList = "services/edit/:serviceId/document-templates",
  documentTemplate = "services/edit/:serviceId/document-template/:documentTemplateId",
  billingConfigurationsList = "services/edit/:serviceId/billing-configurations",
  billingConfiguration = "services/edit/:serviceId/billing-configuration/:billingConfigurationId",
  teamAccess = "services/edit/:serviceId/team-access",
  layouts = "services/edit/:serviceId/layouts",
  layoutManager = "services/edit/:serviceId/layout-manager/:layoutId",
  advancedSettings = "services/edit/:serviceId/advanced-settings",
}
